module.exports = __webpack_public_path__ + "img/hp-logo.05f34c49.png";